export const LOAD_DAY_MENU = 'menu/LOAD_DAY_MENU';
export const LOAD_DAY_MENU_COMPLETE = 'menu/LOAD_DAY_MENU_COMPLETE';
export const LOAD_DAY_MENU_ERROR = 'menu/LOAD_DAY_MENU_ERROR';
export const LOAD_WEEKLY_MENU = 'menu/LOAD_WEEKLY_MENU';
export const LOAD_WEEKLY_MENU_COMPLETE = 'menu/LOAD_WEEKLY_MENU_COMPLETE';
export const LOAD_WEEKLY_MENU_ERROR = 'menu/LOAD_WEEKLY_MENU_ERROR';
